<template>
  <div id="footer">
    <div class="footer-container">
      <transition name="slide">
        <footer
          v-show="showFooter"
          ref="footerRef"
        >
          <div id="copyright">
            <p class="footer-pra">
              Copyright ©2014-2025
              <a
                href="https://91act.com/"
                class="footer-a"
              >
                91Act.com
              </a>
              All Rights Reserved 成都格斗科技有限公司 © ARC SYSTEM WORKS / © 91Act 川B2-20180234 川网文[2017] 9950-404号
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002001031"
                class="footer-a"
              >
                川公网安备 51019002001031号
              </a>
              <a
                href="https://beian.miit.gov.cn/"
                class="footer-a"
              >
                蜀ICP备16027783号
              </a>
            </p>
            <p class="footer-pra">
              健康游戏公告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
            </p>
          </div>
        </footer>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFooter: true
    }
  },
  methods: {
    toggleFooter() {
      this.showFooter = !this.showFooter
    }
  }
}
</script>

<style lang="scss">
.footer-container {
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 10;
  bottom: -57px;
  width: 100%;
}

.footer-copyright-btn {
  position: absolute;
  right: 20px;
  bottom: 40px;
  z-index: 20;
  cursor: pointer;
}

#copyright {
  height: 100%;
  background: rgb(0, 0, 0, 0.5);
  padding: 5px 0 5px;

  font-size: 12px;
  font-family: "MiSans-Medium";
}

.footer-pra {
  text-align: center;
  margin: 5px;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
}

.footer-a {
  cursor: pointer;
  color: white;
}
</style>
